import React from "react";
import { useNavigate } from "react-router-dom";
import { FiShoppingCart, FiMapPin, FiCreditCard, FiCheckCircle } from "react-icons/fi";
import "./CheckoutStepper.css";

const steps = [
  { label: "Cart", icon: <FiShoppingCart size={18} />, path: "/cart" },
  { label: "Address", icon: <FiMapPin size={18} />, path: "/address" },
  { label: "Payment", icon: <FiCreditCard size={18} />, path: "/Checkout" },
  { label: "Confirmation", icon: <FiCheckCircle size={18} />, path: "/OrderConfirm" },
];

const CheckoutStepper = ({ currentStep = 0 }) => {
  const navigate = useNavigate();

  const handleClick = (index, path) => {
    if (index < currentStep) navigate(path);
  };

  return (
    <div className="checkout-stepper">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;
        const isClickable = index < currentStep;

        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <div className={`stepper-line ${isCompleted || isActive ? "stepper-line--active" : ""}`} />
            )}
            <div
              className={`stepper-item ${isActive ? "stepper-item--active" : ""} ${isCompleted ? "stepper-item--completed" : ""} ${isClickable ? "stepper-item--clickable" : ""}`}
              onClick={() => handleClick(index, step.path)}
            >
              <div className="stepper-icon">{step.icon}</div>
              <span className="stepper-label">{step.label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CheckoutStepper;
